import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Observable, ReplaySubject} from "rxjs";
import {Regional} from "../../../shared/interface/regional";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {AuthService} from "../../../shared/services/auth.service";
import {MatDialog} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";
import {Router} from "@angular/router";
import {RegionalService} from "../../../shared/services/regional.service";
import {takeUntil} from "rxjs/operators";


@Component({
  selector: 'app-regional-details-view',
  templateUrl: './regional-details-view.component.html',
  styleUrls: ['./regional-details-view.component.scss']
})
export class RegionalDetailsViewComponent implements OnInit, OnDestroy {
  @Input() regional: Observable<Regional>;
  @Output() modifyClicked = new EventEmitter<any>();

  userPermissions: ReplaySubject<UserPermissions>;
  regionalObject?: Regional;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private auth: AuthService,
    private dialog: MatDialog,
    private regionalService: RegionalService,
    private snack: MatSnackBar,
    private router: Router,
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
    this.regional
      .pipe(takeUntil(this.destroyed$))
      .subscribe((regional: Regional) => {
        this.regionalObject = regional;
      });
  }
  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
  modify(): void {
    this.modifyClicked.emit();
  }
}
